import React from "react";
import { Text } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";

export type ChipVariant = "contacts" | "accounts" | "opportunities" | "activities";

interface ChipProps {
  variant: ChipVariant;
  children: React.ReactNode;
  className?: string;
}

const Chip: React.FC<ChipProps> = ({ variant, children, className }) => {
  const getChipStyle = () => {
    switch (variant) {
      case "contacts":
        return styles.chipContacts;
      case "accounts":
        return styles.chipAccounts;
      case "opportunities":
        return styles.chipOpportunities;
      case "activities":
        return styles.chipActivities;
      default:
        return styles.chipContacts;
    }
  };

  const combinedClassName = className ? `${getChipStyle()} ${className}` : getChipStyle();

  return (
    <Text variant="regular-sm" className={combinedClassName}>
      {children}
    </Text>
  );
};

export default Chip;
